<template>
  <v-layout row justify-start align-center>
    <v-flex class="flex-shrink">
      <v-btn-toggle
        v-model="colorToolbar"
        class="toolbar-height elevation-0 ml-1"
        style="width: 40px;"
      >
        <v-btn class="toolbar-height color-btn" flat>
          <v-icon
            :style="{ color: backgroundColor.hex === '#FFFFFF' ?
              '#a6a6a6' : backgroundColor.hex }"
          >
            format_color_fill
          </v-icon>
        </v-btn>
        <div class="color-picker">
          <color-picker v-if="isOpenColorPicker()" v-model="backgroundColor" @input="onColorChange" />
        </div>
      </v-btn-toggle>
    </v-flex>
    <v-flex v-if="extraModules.categoriesAndZones" class="pa-0">
      <v-switch
        v-model="isCategory"
        class="pa-0 ma-0"
        hide-details
        :label="adminText('workflowsAll.use_category_color_c24e42c', 'Use category color')"
        color="primary"
        @change="onCategoryChange"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { Sketch } from 'vue-color'

export default {
  mixins: [WorkflowDisplay],
  name: 'color-toolbar',
  components: {
    'color-picker': Sketch,
  },
  props: {
    styles: Object,
    extraModules: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      backgroundColor: { hex: this.styles.backgroundColor },
      colorToolbar: -1,
      isCategory: this.styles.isCategory,
    }
  },
  watch: {
    styles: {
      handler({ backgroundColor, isCategory }) {
        this.backgroundColor = {
          hex: backgroundColor,
        }
        this.isCategory = isCategory
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isOpenColorPicker() {
      return this.colorToolbar === 0
    },
    onColorChange(color) {
      this.$emit('update:styles', {
        backgroundColor: color.hex,
      })
    },
    onCategoryChange() {
      this.$emit('update:styles', {
        isCategory: this.isCategory,
      })
    },
  },
}
</script>

<style scoped>
.color-picker {
  position: absolute;
  top: 50px;
  left: 12px;
  z-index: 150;
}
.color-btn {
  opacity: 1;
}
</style>
